import { all } from 'redux-saga/effects';
import authSaga from './authSaga';
import pickleSaga from './pickleSaga';
import orderSaga from './orderSaga';
import cartSaga from './cartSaga';

export default function* rootSaga() {
  yield all([
    authSaga(),
    pickleSaga(),
    orderSaga(),
    cartSaga(),
  ]);
}